import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  selectInput: {
    backgroundColor: theme.palette.white,
  },
}))

export default styles
